interface FetchApiOptions {
  maxRetries?: number;
  retryDelay?: number;
  headers?: Record<string, string>;
  method?: string;
  data?: any;
}

export async function fetchApi(url: any, options: FetchApiOptions = {}) {
  const {
    maxRetries = 1,
    retryDelay = 1000,
    headers = {},
    method = "GET",
    data = null,
  } = options;
  let retries = 1;

  while (retries <= maxRetries) {
    try {
      const controller = new AbortController();
      const signal = controller.signal;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          ...headers, // merge the provided headers with the default headers
        },
        body: data && JSON.stringify(data),
        signal,
      });

      if (response.status === 500) {
        throw new Error("Internal Server Error");
      }

      if (response.status === 404) {
        throw new Error("Resource Not Found");
      }

      if (!response.ok) {
        throw new Error("Something went wrong. Please try again later.");
      }

      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      if (error.name === "AbortError") {
        console.error("Request cancelled");
        throw new Error("Request cancelled");
      }

      console.error(error);
      retries++;
      await new Promise((resolve) => setTimeout(resolve, retryDelay));
      continue;
    }
  }

  throw new Error(`Failed to fetch API after ${maxRetries} attempts.`);
}
